<template>
  <div v-if="customer" class="gmf-customer-stats-expanded">
    <a href="#" class="gmf-customer-stats-expanded-stat gmf-clickable" @click="openTab($event, 'my_content')">
      <span class="gmf-customer-stats-expanded-number">{{ customer.commentCount }}</span>
      <span class="gmf-text-small">{{ t('comments') }}</span>
    </a>
    <template v-if="showAchievements">
      <a v-if="achievementsClickable" href="#" class="gmf-customer-stats-expanded-stat gmf-clickable" @click="openTab($event, 'achievements')">
        <span class="gmf-customer-stats-expanded-number">{{ customer.unlockedAchievementCount }}</span>
        <span class="gmf-text-small">{{ t('achievements') }}</span>
      </a>
      <div v-else class="gmf-customer-stats-expanded-stat">
        <span class="gmf-customer-stats-expanded-number">{{ customer.unlockedAchievementCount }}</span>
        <span class="gmf-text-small">{{ t('achievements') }}</span>
      </div>
    </template>
    <a href="#" class="gmf-customer-stats-expanded-stat gmf-clickable" @click="openTab($event, 'my_content')">
      <span class="gmf-customer-stats-expanded-number">{{ customer.receivedUpvoteCount }}</span>
      <span class="gmf-text-small">{{ t('likes') }}</span>
    </a>
    <template v-if="isMyProfile && showTokenShop  && tokenBalances">
      <a href="#" class="gmf-customer-stats-expanded-stat gmf-clickable" v-for="token in tokenBalances" :key="token.uuid" @click="openTokenShop">
        <span class="gmf-customer-stats-expanded-number gmf-customer-stats-expanded-token"><img :src="token.token.icon" class="gmf-token"/>{{ token.amount }}</span>
        <span class="gmf-text-small">{{ t('coins') }}</span>
      </a>
    </template>
    <div class="gmf-customer-stats-expanded-stat" v-if="showLootCrateButton">
      <LootCrateButton />
    </div>
    <a
      href="#"
      class="gmf-customer-stats-expanded-stat gmf-customer-stats-expanded-tutorial gmf-clickable"
      v-if="tutorialEnabled"
      @click="openTutorialModal"
      aria-label="Open tutorial"
    >
      <Icon icon="question" />
    </a>
  </div>
</template>

<style>
  .gmf-customer-stats-expanded {
    display: flex;
    gap: var(--gmf-p-4);
    flex-wrap: wrap;
  }
  .gmf-customer-stats-expanded-stat {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: var(--gmf-p-2);

    /* a tag reset */
    color: inherit;
    text-decoration: none;
  }
  .gmf-customer-stats-expanded-number {
    font-size: var(--gmf-subheader-font-size);
    font-weight: bold;
  }
  .gmf-customer-stats-expanded-token {
    display: flex;
    align-items: center;
    gap: var(--gmf-p-1);
    margin-top: -1px;
  }
  .gmf-customer-stats-expanded-token .gmf-token, .gmf-customer-stats-expanded-tutorial svg {
    margin-top: -1px;
  }
  .gmf-customer-stats-expanded .gmf-clickable {
    cursor: pointer;
  }
  .gmf-customer-stats-expanded .gmf-icon {
    height: 32px;
    min-width: 32px;
    --gmf-icon-color: var(--gmf-col-nearblack);
  }
</style>

<script>
import state from '@/state';
import callApi from '@/utils/callApi';
const t = state.t.prefix('customer_stats');

import Icon from '@/components/Icon.vue';

import { getMyTokenBalance } from '@/utils/getMyTokenBalance';
import openTutorialModal from '@/widgets/Tutorial/openTutorialModal';
import LootCrateButton from '@/components/LootCrates/LootCrateButton';
import openTokenShop from './TokenShop/openTokenShop';
import openPopupProfileCard from '@/components/PopupProfileCard/openPopupProfileCard';

export default {
  props: ['customer'],
  data() {
    return {
      t,
      tokenBalances: null,
      totalLootCrates: 0,
    }
  },
  components: {
    Icon,
    LootCrateButton,
  },
  computed: {
    isMyProfile() {
      return this.customer.id === state.profile?.id;
    },
    showTokenShop() {
      return state.merchantConfig.tokenShop?.enabled;
    },
    tutorialEnabled() {
      return state.merchantConfig.widgets?.tutorial?.enabled;
    },
    use3DAvatar () {
      return state.merchantConfig.avatars.enabled === '3D';
    },
    showLootCrateButton() {
      return this.isMyProfile && ! this.use3DAvatar && this.totalLootCrates > 0
    },
    showAchievements() {
      return state.merchantConfig.achievements?.enabled || false;
    },
    achievementsClickable() {
      return this.isMyProfile || ! state.merchantConfig.achievements?.hideFromOthers;
    },
  },
  methods: {
    openTab(ev, tab) {
      openPopupProfileCard(this.customer.id, tab);
      ev.preventDefault();
    },
    openTokenShop,
    openTutorialModal,
    async getLootCrateCount() {
      const request = await callApi('GET', '/v1/client/my-loot-crates');
      const { totalQuantity } = await request.json();
      this.totalLootCrates = totalQuantity;
    },
  },
  async mounted() {
    if (this.isMyProfile) {
      this.tokenBalances = await getMyTokenBalance();
      if (! this.use3DAvatar) {
        this.getLootCrateCount();
      }
    }
  },
};
</script>
